import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V4H17V8H7V4H6V2ZM11 4.49805V6.50195H13.0039V4.49805H11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 10H8V23H2V19H3V16H4L4 13H5V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 10H10V23H14V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 10H16V23H22V19H21V16H20V13H19V10Z"}}]};

const PyramidMayaFilled = Vue.extend<IconProps>({
  name: 'PyramidMayaFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'pyramid-maya-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PyramidMayaFilled;
